(function () {
  'use strict';

  // Constants
  const SELECTORS = {
    SECTION: '[data-section-type="class-tab-toggle"]',
    TAB: '[data-tab-id]',
    TABS_CONTAINER: '.class-tab-toggle__tabs',
    ARROW_CIRCLE: '.class-tab-toggle__arrow-circle',
  };

  const CLASSES = {
    ACTIVE: 'is-active',
    HIDDEN: 'class-tab-toggle__hidden',
    ANIMATE: 'animate',
  };

  const SCROLL_OPTIONS = {
    behavior: 'smooth',
    block: 'start',
  };

  const instances = new Map();

  /**
   * 指定されたクラスリストの要素の表示/非表示を切り替える
   */
  function toggleElementsByClass(classList, shouldHide) {
    classList.forEach((className) => {
      document.querySelectorAll(`.${className}`).forEach((element) => {
        element.classList.toggle(CLASSES.HIDDEN, shouldHide);
      });
    });
  }

  /**
   * タブの状態を更新する
   */
  function updateTabState(tabs, activeTabId) {
    tabs.forEach((tab) => {
      const isActive = tab.dataset.tabId === activeTabId;
      // ラッパー要素にis-activeクラスを追加
      const wrapper = tab.closest('.class-tab-toggle__tab-wrapper');
      if (wrapper) {
        wrapper.classList.toggle(CLASSES.ACTIVE, isActive);
      }
      tab.setAttribute('aria-selected', String(isActive));
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });
  }

  /**
   * コンテンツの表示/非表示を切り替える
   */
  function toggleContentVisibility(mapping, activeTabId) {
    Object.entries(mapping).forEach(([tabId, classList]) => {
      const shouldHide = tabId !== activeTabId;
      toggleElementsByClass(classList, shouldHide);
    });
  }

  /**
   * 矢印のアニメーションをトリガーする
   */
  function triggerArrowAnimation(section) {
    const arrowCircle = section.querySelector(SELECTORS.ARROW_CIRCLE);
    if (!arrowCircle) return;

    // アニメーションクラスを削除して再追加（再トリガー用）
    arrowCircle.classList.remove(CLASSES.ANIMATE);
    // 次のフレームで追加（CSSアニメーションの再トリガー）
    requestAnimationFrame(() => {
      arrowCircle.classList.add(CLASSES.ANIMATE);
    });

    // アニメーション終了後にクラスを削除
    arrowCircle.addEventListener('animationend', function onAnimationEnd() {
      arrowCircle.classList.remove(CLASSES.ANIMATE);
      arrowCircle.removeEventListener('animationend', onAnimationEnd);
    });
  }

  /**
   * タブをアクティブ化し、必要に応じてスクロールする
   */
  function activateTab(tabs, mapping, tabsContainer, section, tabId, shouldScroll = false, shouldAnimate = false) {
    updateTabState(tabs, tabId);
    toggleContentVisibility(mapping, tabId);

    if (shouldAnimate) {
      triggerArrowAnimation(section);
    }

    if (shouldScroll && tabsContainer) {
      tabsContainer.scrollIntoView(SCROLL_OPTIONS);
    }
  }

  /**
   * タブのクリックイベントハンドラー
   */
  function handleTabClick(tabs, mapping, tabsContainer, section, tabId) {
    activateTab(tabs, mapping, tabsContainer, section, tabId, true, true);
  }

  /**
   * タブのキーボードイベントハンドラー
   */
  function handleTabKeydown(event, tabs, mapping, tabsContainer, section, tabId) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      activateTab(tabs, mapping, tabsContainer, section, tabId, true, true);
    }
  }

  /**
   * マッピングJSONをパースする
   */
  function parseMapping(mappingJson) {
    try {
      return JSON.parse(mappingJson);
    } catch (error) {
      console.warn('class-tab-toggle: mapping JSON parse error', error);
      return null;
    }
  }

  /**
   * セクションを初期化する
   */
  function init(section) {
    const tabs = Array.from(section.querySelectorAll(SELECTORS.TAB));
    if (!tabs.length) return;

    const mappingJson = section.dataset.mapping;
    if (!mappingJson) return;

    const mapping = parseMapping(mappingJson);
    if (!mapping) return;

    const tabsContainer = section.querySelector(SELECTORS.TABS_CONTAINER);

    // イベントリスナーを設定
    tabs.forEach((tab) => {
      const tabId = tab.dataset.tabId;

      tab.addEventListener('click', () => {
        handleTabClick(tabs, mapping, tabsContainer, section, tabId);
      });

      tab.addEventListener('keydown', (event) => {
        handleTabKeydown(event, tabs, mapping, tabsContainer, section, tabId);
      });
    });

    // デフォルトタブをアクティブ化
    const defaultTab = tabs.find((tab) => {
      const wrapper = tab.closest('.class-tab-toggle__tab-wrapper');
      return wrapper && wrapper.classList.contains(CLASSES.ACTIVE);
    }) || tabs[0];
    if (defaultTab) {
      activateTab(tabs, mapping, tabsContainer, section, defaultTab.dataset.tabId, false, false);
    }

    // インスタンスを保存
    instances.set(section.dataset.sectionId, {
      activate: (tabId) => activateTab(tabs, mapping, tabsContainer, section, tabId, false, false),
    });
  }

  /**
   * セクションを破棄する
   */
  function destroy(sectionId) {
    instances.delete(sectionId);
  }

  /**
   * 指定されたセクションタイプのイベントハンドラー
   */
  function handleSectionEvent(event, handler) {
    if (event.target.dataset.sectionType === 'class-tab-toggle') {
      handler(event.target);
    }
  }

  // 初期化
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(SELECTORS.SECTION).forEach(init);
  });

  // Shopify テーマエディター対応
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      handleSectionEvent(event, init);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      handleSectionEvent(event, (target) => destroy(target.dataset.sectionId));
    });
  }
})();
